function StatusUtils() {

    // 10:'待提交', 20:'已提交', 30:'发布中', 40:'全部接单' 
    const getOrderStatus = (val, row?) => {
        if (val == 10) {
            return '#EE9A00';
        } else if (val == 30) {
            return '#F56C6C';
        } else if (val == 20) {
            return '#23BCCA';
        } else if (val == 40) {
            return '#01A13F';
        }
    }

    const getCheckStatus = (val, row?) => {
        if (val == 10) {
            return '#EE9A00';
        } else if (val == 12) {
            return '#F56C6C';
        } else if (val == 13) {
            return '#01A13F';
        }
    }

    const getCheckFlag = (val, row?) => {
        if (val == 0) {
            return '#EE9A00';
        } else if (val == 1) {
            return '#B15BFF';
        } else if (val == 2) {
            return '#00A600';
        }else if (val == 3) {
            return '#E37884';
        }
    }

    //数字的颜色状态（如到期天数）
        const getDayFlag = (val, row?) => {
        if (val == 0) {
            return 'black';
        } else if (val > 0) {
            return 'green';
        } else if (val < 0) {
            return 'red';
        }
    }

    //用户的状态
    const getUserStatus = (val, row?) => {
        if (val == 10) {
            return '#01A13F';
        } else {
            return '#F56C6C';
        }
    }



      //运单管理状态
      const getWaybillStatus = (val, row?) => {
        if (val == 5) {
            return '#EE9A00';
        } else if(val==10) {
            return '#23BCCA';
        }else if(val==15) {
            return '#01A13F';
        }else if(val==20) {
            return '#999999';  // 已取消状态显示灰色
        }
    }

    //
    const getCheckMoneyStatus = (val, row?) => {
        if (val == 10) {
            return '#23BCCA';
        } else if (val == 20) {
            return '#F56C6C';
        } else if (val == 30) {
            return '#01A13F';
        } else if (val == 0) {
            return 'red';
        }
    }

    //发布状态，10：未接单、未中标，11：报价中，12：已完成，99：已取消
    const getPublishStatus = (val, row?) => {
        if (val == 1) {
            return '#23BCCA';
        } else if (val == 2) {
            return '#F56C6C';
        } else if (val == 3) {
            return '#01A13F';
        } else if (val == 99) {
            return '#F56C6C';
        }
    }

    //10:待申请，20:待打款，30:打款中，40:已打款，50:打款失败，99:退款
    const getPayMoneyStatus = (val, row?) => {
        if (val == 10) {
            return '#23BCCA';
        } else if (val == 20) {
            return '#EE9A00';
        } else if (val == 30) {
            return '#F56C6C';
        }else if (val == 40) {
            return '#01A13F';
        }else if (val == 50) {
            return 'red';
        }else if (val == 99) {
            return '#F56C6C';
        }
    }


        //10:待申请，20:待打款，30:打款中，40:已打款，50:打款失败，99:退款
        const  PayMoneyStatus = (val, row?) => {
            if (val == 1) {
                return '#23BCCA';
            } else if (val == 2) {
                return '#EE9A00';
            } else if (val == 3) {
                return '#01A13F';
            }else if (val == 4) {
                return '#F56C6C';
            }else if (val == 5) {
                return 'red';
            }else if (val == 9) {
                return '#F56C6C';
            }
        }

    //100:待接单，200:已接单，220:运输中，300:已完成，900:已作废
    const getSendShipStatus = (val, row?) => {
        if (val == 100) {
            return '#23BCCA';
        } else if (val == 200) {
            return '#23BCCA';
        } else if (val == 220) {
            return '#F56C6C';
        }else if (val == 300) {
            return '#01A13F';
        }else if (val == 900) {
            return 'red';
        }
    }

    //使用状态，0:空闲，1:工作中
    const getUseStatus = (val, row?) => {
        if (val == 0) {
            return 'green';
        }else {
            return 'red';
        }
    }

    //用户状态：0:正常，1:停用，2:注销
    const getDriverStatus = (val, row?) => {
        if (val == 0) {
            return 'green';
        }else if(val==1 || val==2){
            return 'red';
        }
    }

    //政治面貌：0-群众，1-党员
    const getPoliticalOutlook = (val, row?) => {
        if (val == 0) {
            return '#289934';
        } else {
            return '#ff0302';
        }
    }

    //性别
    const getSex =  (val, row?) => {
        if(val==0){
            return '#ff4b3d';
        }else {
            return '#38b6ff';
        }
    }

    //车辆入网状态
    const getIsOnline = (val, row?)=>{
        if(val==1){
            return 'red';
        } else if(val==2){
            return '#ffa832';
        } else {
            return 'green';
        }
    }

    //销项发票状态
    /**
     *  5: '待申请',
    10: '已申请',
    12: '审核不通过',
    15: '待开票',
    20: '开票中',
    25: '已开票'
     */
    const getInvoiceStatus = (val, row?)=> {
        if(val==5){
            return '#BEBEBE';//灰色
        }else if(val==10){
            return '#FF9224';//黄色
        }else if(val==12){
            return '#FF0000';//红色
        }else if(val==15){
            return '#d0d0d0';//淡灰色
        }else if(val==20){
            return '#EAC100';//深黄色
        }else {
            return '#01A13F';
        }
    }
    const getReportStatus = (val,row?) => {
         if(val==0){
            return '#BEBEBE';//灰色
        }else if(val==1){
            return '#FF9224';//黄色
        }else if(val==2){
            return '#01A13F';//绿色
        }else if(val==3){
            return '#E37884';//红色
        }else {
            return '#01A13F';
        }
    }
    //开户状态,0：未开户，1：开户成功，2：开户失败
    const getOpenStatus = (val,row?) => {
        if(val==1){
            return '#01A13F';//绿色
        }else if(val==2){
            return '#E37884';//红色
        }else {
            return '#BEBEBE';//灰色
        }
    }
    //签署状态,0:待签署，1：签署中，2：签署完成，3：签署失败
    const getSignStatus = (val, row?)=>{
        if (val == 0) {
            return '#EE9A00';
        } else if (val == 1) {
            return '#B15BFF';
        } else if (val == 2) {
            return '#00A600';
        }else if (val == 3) {
            return '#EA0000';
        }
    }

    //车辆属性
    const getIsPersonal = (val,row?)=>{
        if(val==1){
            return '#ffa832';
        }else {
            return '#3a9bf3';
        }
    }
    
    /**
     * 税务开票状态
     * 1:'未开票',4:'已导出',5:'已开票'
     * @param val 
     * @param row 
     */
    const getTaxInvoiceStatus = (val , row?)=>{
        if(val==1){
            return '#BEBEBE';
        }else if(val==4){
            return '#EAC100';
        }else {
            return '#01A13F';
        }
    }


    //运单审核状态
    const getCheckWaybillStatus = (val, row?) => {
        if (val == 5) {
            return '#EE9A00';//橙色（待审核）
        } else if (val == 9) {
            return '#1890FF';//蓝色（预审通过，与审核通过做色号区分）
        } else if (val == 10) {
            return '#01A13F';//绿色（审核通过）
        } else if (val == 14) {
            return '#F56C2D';//深橙（预审不通过，与审核不通过做色号区分）
        } else if (val == 15) {
            return '#EA0000';//红色（审核不通过）
        }
    }
    
    //状态：0-待处理；5-已处理；10-已完成
    const getRiskStatus = (val, row?) => {
        if (val == 0) {
            return '#EA0000';
        } else if (val == 5) {
            return '#EE9A00';
        } else if (val == 10) {
            return '#01A13F';//绿色
        }
    }

    //审核状态：0-待审核；5-审核通过；10-审核不通过
    const getRiskCheckStatus = (val, row?) => {
        if (val == 0) {
            return '#EE9A00';
        } else if (val == 5) {
            return '#01A13F';//绿色
        } else if (val == 10) {
            return '#EA0000';//红色
        }
    }

    //纠正状态：5-待提交，10-待审核，15-审核不通过，20-已处理
    const getCorrectStatus = (val, row?) => {
        if(val==5){
            return '#BEBEBE';//灰色
        }else if(val==10){
            return '#FF9224';//黄色
        }else if(val==15){
            return '#FF0000';//红色
        }else if(val==20){
            return '#01A13F';//深黄色
        }
    }
    
    /**
     * 会员发票类型
     * 0:'普通发票',1:'专用发票'
     */
    const getInvoiceType = (val , row?)=>{
        if(val==0){
            return '#EE9A00';
        }else if(val==1){
            return '#B15BFF';
        }else {
            return '#01A13F';
        }
    }

    /**
     * 会员开票表发票状态
     * 0:'已开票',1:'已作废'
     */
    const getMemberInvoiceStatus = (val , row?)=>{
        if(val==0){
            return '#01A13F';//已开票
        }else if(val==1){
            return '#FF0000';//已作废
        }else {
            return '#EAC100';
        }
    }
    const getPaymentStautsColor = (val , row?) =>  {
        if (val == 1) {
            return '#BEBEBE'; // 待支付 - 灰色
        } else if (val == 2) {
            return '#FF9224'; // 支付中 - 黄色
        } else if (val == 3) {
            return '#01A13F'; // 已支付 - 绿色
        } else if (val == 4) {
            return '#d0d0d0'; // 支付失败 - 红色
        } else if (val == 5) {
            return '#FF0000'; // 已退款 - 淡灰色
        } else if (val == 6) {
            return '#EAC100'; // 退款中 - 深黄色
        } else if (val == 7) {
            return '#999999'; // 退款失败 - 中灰
        } else {
            return '#01A13F'; // 默认绿色
        }
    }

    return {
        getDayFlag : getDayFlag, //天数类型（数字）
        getCheckFlag : getCheckFlag,
        getOrderStatus : getOrderStatus,    // 
        getCheckStatus : getCheckStatus,
        getUserStatus : getUserStatus,
        getCheckMoneyStatus : getCheckMoneyStatus,
        getPayMoneyStatus : getPayMoneyStatus,
        PayMoneyStatus : PayMoneyStatus,
        getPublishStatus : getPublishStatus,
        getSendShipStatus : getSendShipStatus,
        getUseStatus : getUseStatus,
        getDriverStatus:getDriverStatus,
        getPoliticalOutlook:getPoliticalOutlook,
        getSex:getSex,
        getIsOnline:getIsOnline,
        getIsPersonal:getIsPersonal,
        getWaybillStatus:getWaybillStatus,
        getCheckWaybillStatus:getCheckWaybillStatus,
        getReportStatus:getReportStatus,
        getOpenStatus:getOpenStatus,
        getSignStatus:getSignStatus,
        getInvoiceStatus:getInvoiceStatus,
        getTaxInvoiceStatus:getTaxInvoiceStatus,
        getRiskStatus:getRiskStatus,
        getRiskCheckStatus:getRiskCheckStatus,
        getCorrectStatus:getCorrectStatus,

        getInvoiceType:getInvoiceType,
        getMemberInvoiceStatus:getMemberInvoiceStatus,
        getPaymentStautsColor:getPaymentStautsColor,
    }

}

export default StatusUtils();
